<div class="not-found-content container centered-content">
    <div class="container centered-content spinner-content" *ngIf="loading$ | async">
        <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
    </div>
    <div class="container centered-content" *ngIf="!(loading$ | async) && (nodes$ | async)?.length == 0">
        <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
        <div>No Nodes Found</div>
    </div>
    <div *ngIf="(nodes$ | async) && (nodes$ | async)?.length > 0">
    </div>
</div>
<nodes></nodes>

<div class="zoom-toolbar">
    <button class="zoom-btn" (click)="zoomIn()">+</button>
    <button class="zoom-btn" (click)="zoomOut()">−</button>
    <button class="zoom-btn" (click)="resetZoom()">⟳</button>
</div>

<div class="add-save-content">
    <button mat-flat-button color="primary" (click)="openAddNodeDialog()">
        <mat-icon>add</mat-icon> Node
    </button>
    <button mat-flat-button color="primary" (click)="saveFlow()">
        Save Flow
    </button>
</div>